module.exports = __webpack_public_path__ + "img/pro-d4.998014ad.jpg";